import React from 'react';
import { translate, getLocaldmYDate } from 'utils/common';
import isEmpty from 'lodash.isempty';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/light.css';
import PasswordValidator from 'components/passwordvalidator';
import RadioGroup from 'common/radiogroup';
import { WithContext as ReactTags } from 'react-tag-input';
import classNames from 'classnames/bind';
import SelectImage from 'common/selectimage';
import MultiSelect from 'components/common/multiselect';
import TextEditor from 'components/texteditor';

import SelectField from 'components/common/selectfield';
import { DatePicker } from 'components/common/datepicker/datepicker';
import AddressComp from 'components/common/address';
import ShuttleBox from 'components/common/shuttlebox';
import ProductSearch from 'components/common/productSearch/productSearch';
import ProductSuggestWrapper from 'components/common/autoSuggest/productSuggestWrapper';
import TimePickerWrapper from 'components/common/timePicker/timePicker';
import CheckBox from 'components/common/checkbox';
import 'assets/sass/forms.scss';

function getField(props, validator) {
    let fieldClassName = props.fieldClassName || 'form-control' 
    let p = {
        id: (props.id || (props.name + new Date().getTime())),
        name: (props.nameAlias || props.name),
        //onChange:props.onChange,
        value: ((props.value != null && props.value != undefined && props.value.length != 0) ? props.value : ''),
        className: (fieldClassName + " " + (validator && validator.isInvalid && 'is-invalid')),
        placeholder: translate(props.placeholder),
        disabled: props.readOnly,
        ismulti: props.isMulti,
        isclearable: props.isClearable,
        isDisabled:props.readOnly,
        //readOnly: props.readOnly,
        ...(props.rows ? { rows: props.rows } : {}),
        ...(props.min ? { min: props.min } : {}),
        options: props.options || [],
    }
    if(props.type === "productsearch") {
        p.value = p.value || [];
        p.fullData =  props.fullData;
        p.formInfo = props.formInfo || null
        p.maxitems = props.maxitems || null

    }
    if (props.type === "autosuggest") {
        p.value = p.value || {};
        p.fullData =  props.fullData; 
        p.formInfo = props.formInfo || null
    }
    if (props.type === 'media' || props.type === 'objects') {
        p.formInfo = props.formInfo || null
        p.customProps = {allowedTypes: props.allowedTypes || [], allowedExtensions: props.allowedExtensions || []}
    }
    props.maxLength && (p.maxLength = props.maxLength);
    if (props.type == 'timepicker') {
        p.showSecond = typeof props.showSecond == "undefined" ? true : props.showSecond
        props.defaultValue && (p.defaultValue = props.defaultValue);
        !props.value && (p.value = null);
    }
    if (undefined != props.value && 'undefined' != typeof props.value && props.allowZeroValue == 'Y' && (props.value + '').trim().length > 0 && p.value == 0) {
        p.value = 0;
    }
    if (props.type == 'checkbox') {
        p.checked = props.checked || false
    }
    let dp = {
        altInput: true,
        altFormat: 'd-m-Y',
        minDate: props.minDate || '',
        maxDate: props.maxDate || '',
        onReady: props.onReady || function () {
            /* 
                flatpickr default flow is to empty 
                preloaded(set) inputs where validation fails
                but that leads to empty inputs & user gets confused or don't know
                the already saved date, so the fix below
             */
            var that = this;
            if (!that.input.value) {
                // direct changing is not working, as its being overwritten by this flatpickr-react plugin
                setTimeout(() => {
                    const prefillValue = props.value ? getLocaldmYDate(props.value) : '';
                    that.input.value = prefillValue;
                    // pseudo input element fix for alInput format prefilling validated dates
                    if (that.input.parentElement.children.length > 1) {
                        that.input.parentElement.children[1].value = prefillValue;
                    }
                }, 14);
            }
        }
    };
    props.onChange && (p['onChange'] = props.onChange);
    props.onKeyPress && (p['onKeyPress'] = props.onKeyPress);
    props.onBlur && (p['onBlur'] = props.onBlur);
    let type = props.type || 'text';

    // datepicker specific event listeners
    props.onClear && (p['onClear'] = props.onClear);

    switch (props.type) {
        case 'textarea': return <textarea {...p} ></textarea>
        case 'select': return <SelectField {...p} {...props} />
        case 'multiselect': return <MultiSelect {...p} />
        case 'selectimage': return <SelectImage id={p.id} name={p.name} options={props.selectOptions} value={p.value} onChange={p.onChange} value={p.value} multi={props.multi} readOnly={props.readOnly} />
        case 'date': return <DatePicker {...props} {...p} />
        case 'password': return <PasswordInput type={type}
            //validatorToolTip={props.validatorToolTip} onChanged={props.onChanged}
            // requireNumbers={props.requireNumbers} requireCapitals={props.requireCapitals}
            // minCharacters={props.minCharacters} 
            p={p} {...props} />
        case 'taginput': return <TagInput {...p} />
        case 'emailphone': return <EmailPhone {...p} />
        case 'phone': return <Phone {...p} />
        // checkbox has to come at last just above return <input
        case 'texteditor': return <TextEditor {...p} readOnly={props.readOnly} />
        case 'timepicker': return <TimePickerWrapper  {...p} />
        case 'address': return <AddressComp {...props} {...p} />
        case 'radiogroup': return <RadioGroup  {...props} />
        // case 'checkbox': return <Checkbox2 {...p} checked= {!!props.checked} />
        case 'objects': return <ShuttleBox {...p} variation="default"></ShuttleBox>
        case 'media': return <ShuttleBox {...p} folderId={props.folderId} variation="tree"></ShuttleBox>
        case 'productsearch': return <ProductSearch {...p}></ProductSearch>
        case 'autosuggest': return <ProductSuggestWrapper {...p}/>
        case 'checkbox': return <CheckBox type={type} {...p} defaultChecked={!!props.checked}  />
        // case 'checkbox': p['checked'] = !!props.checked; //break;
        default: return <input type={type} {...p} />
    }
}

// function CheckBox(props){
//     function handleClick(e){
//         if(props.onChange) props.onChange({target:{name:props.name, value:e.target.checked}})
//     }
//     // return <input {...props} checked={props.defaultChecked} onClick={handleClick} onChange={null} />
//     return <input {...props} onClick={handleClick} onChange={null} />
//     // return <input {...props} defaultChecked={props.defaultChecked} onClick={handleClick} onChange={null} />
// } 

// class Checkbox2 extends React.Component {
//     constructor(props) {
//         super(props);
//         this.onChange = this.onChange.bind(this);
//         // this.state = {
//         //     checked: this.props.checked || false
//         // };
//     }
//     componentDidUpdate(prevProps) {
//         // if (this.props.checked != prevProps.checked) {
//         //      this.setState({ checked: this.props.checked })
//         // }
//     }
//     onChange(e) {

//         // this.setState({ checked: !e.currentTarget.checked }, () => {
//             this.props.onChange({
//                 target: {
//                     inputtype: 'phone', 
//                     name: this.props.name, 
//                     value: e.target.checked
//                 }
//             }); 
//             // value: this.processOutput(isnum, e.target.value) }});
//         // });
//     }
//     render() {
//         return (<React.Fragment>
//             <input {...this.props} type="checkbox" checked={!!this.props.checked}  onClick={this.onChange} />
//             {/* <input {...this.props} checked={!!this.props.checked}  onClick={this.onChange} /> */}
//         </React.Fragment>
//         );
//     }
// }

function RemainingChars (inputs){
    let remaingChars = inputs.maxChar-(inputs.value? inputs.value.length:0)     
    var clsnames = classNames({
        'remaining-chars': true,
        'text-success': remaingChars >= 0,
        'text-danger': !remaingChars || remaingChars< 0 
    })
    return (
        <React.Fragment>
            {inputs.maxChar && inputs.maxChar> 0 && 
                <span className={clsnames} title={remaingChars+" Characters Remaining"}>
                    {remaingChars}</span>
            }
        </React.Fragment>
    )                                
}


class Phone extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this)
        this.cbOnChange = this.cbOnChange.bind(this)

        this.countryCodeOptions = []
        app.countryCodes.forEach(item => {
            this.countryCodeOptions.push({ text: item, value: item })
        });
        this.state = {
            countryCode: this.countryCodeOptions[0].value, inputvalue: ''
        };
    }
    componentDidMount() {
        // var isnum = /^\d+$/.test(inputvalue);
        let { value } = this.props
        if (value.includes('+')) {
            this.setState({ countryCode: value.substring(0, 3), inputvalue: value.substring(3) })
        } else this.setState({ inputvalue: value })
    }
    componentDidUpdate(prevProps) {
        if (this.props.value != prevProps.value) {
            let { value } = this.props;
            if (value.includes('+')) {
                this.setState({ countryCode: value.substring(0, 3), inputvalue: value.substring(3) })
            } else this.setState({ inputvalue: value })
        }
    }
    onChange(e) {
        this.setState({ inputvalue: e.target.value }, () => {
            this.props.onChange({
                target: {
                    inputtype: 'phone', name: this.props.name, //countryCode:this.state.countryCode, 
                    value: this.state.inputvalue ? this.state.countryCode + this.state.inputvalue : ''
                }
            });
            // value: this.processOutput(isnum, e.target.value) }});
        });
    }
    cbOnChange(e) {
        this.setState({ countryCode: e.target.value }, () => {
            this.props.onChange({
                target: {
                    inputtype: 'phone', name: this.props.name, //countryCode:this.state.countryCode, 
                    value: this.state.countryCode + this.state.inputvalue
                }
            });
        });
    }
    render() {
        return (<React.Fragment>
            {this.state.countryCode &&
                <SelectField readOnly={this.props.disabled} disabled={this.props.disabled} value={this.state.countryCode} onChange={this.cbOnChange} selectOptions={this.countryCodeOptions} />
            }
            <input {...this.props} value={this.state.inputvalue} onChange={this.onChange} />
            <small className="field-info">{translate('seller.login.phone_help')}</small>
        </React.Fragment>
        );
    }
}

class EmailPhone extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onChange = this.onChange.bind(this)
        this.cbOnChange = this.cbOnChange.bind(this)
        this.state = {
            countryCode: null, inputvalue: null
        };
        this.countryCodeOptions = []
        app.countryCodes.forEach(item => {
            this.countryCodeOptions.push({ text: item, value: item })
        });
    }
    componentDidMount() {
        // var isnum = /^\d+$/.test(inputvalue);
        // if(isnum) this.setState({countryCode:'+66'})
    }
    onChange(e) {
        var isnum = /^\d+$/.test(e.target.value);
        let countryCode = null;
        if (isnum) {
            countryCode = (this.state.countryCode || this.countryCodeOptions[0].value);
            // countryCode = (e.target.id=='select')? e.target.value: (this.state.countryCode || '+66');
        }

        this.setState({ inputvalue: e.target.value, countryCode: countryCode }, () => {
            this.props.onChange({
                target: {
                    inputtype: 'emailphone', name: this.props.name, countryCode: this.state.countryCode,
                    value: this.state.inputvalue
                }
            });
            // value: this.processOutput(isnum, e.target.value) }});
        });
    }
    cbOnChange(e) {
        this.setState({ countryCode: e.target.value }, () => {
            this.props.onChange({
                target: {
                    inputtype: 'emailphone', name: this.props.name, countryCode: this.state.countryCode,
                    value: this.state.inputvalue
                }
            });
        });
    }
    processOutput(value) {
        return value
    }
    render() {
        // const { p } = this.props;
        return (<React.Fragment>
            {this.state.countryCode &&
                <SelectField value={this.state.countryCode} onChange={this.cbOnChange} selectOptions={this.countryCodeOptions} />

                // <select value={this.state.countryCode} onChange={this.cbOnChange} >
                //     {
                //         this.countryCodeOptions.map((o, i) => <option key={i} value={o.value}>{translate(o.text)}</option>)
                //     }
                // </select>
            }
            <input {...this.props} value={this.state.inputvalue} onChange={this.onChange} />

        </React.Fragment>
        );
    }
}

class TagInput extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            tags: this.props.value ? this.processInputvalue(this.props.value) : []
        };
        this.KeyCodes = {
            tab: 9,
            enter: 13
        };
        this.delimiters = [this.KeyCodes.tab, this.KeyCodes.enter];
        this.handleDelete = this.handleDelete.bind(this);
        this.handleAddition = this.handleAddition.bind(this);
        this.handleInputBlur = this.handleInputBlur.bind(this);
        // this.handleDrag = this.handleDrag.bind(this);  
    }
    processInputvalue(data) {
        let returnVal = [];
        data.map((item, index) => {
            returnVal.push({ "id": index.toString(), "text": item.text ? item.text : (typeof item == 'string' ? item : ''), className: item.className ? item.className : (item.disabled ? 'disabled' : '') })
        })
        return returnVal;
    }
    processOutput(data) {
        let returnVal = [];
        data.map((item) => {
            returnVal.push({ "text": item.text, className: item.className })
        })
        return returnVal;
    }
    componentDidUpdate(prevProps) {
        if (this.props.value != prevProps.value) {
            this.setState({ tags: this.processInputvalue(this.props.value) })
        }
    }
    handleDelete(i) {
        this.setState({
            tags: this.state.tags.filter((tag, index) => index !== i),
        }, () => {
            this.props.onChange({ target: { inputtype: 'taginput', name: this.props.name, value: this.processOutput(this.state.tags) } });
        });
    }

    handleInputBlur(tag) {
        tag = tag.trim();
        if (tag) {
            this.handleAddition({ id: tag, text: tag });
        }
    }

    handleAddition(tag) {
        tag.id = tag.id.trim().toLowerCase();
        tag.text = tag.text.trim();
        let { tags } = this.state;
        // this.setState({ tags: [...tags, { id: tags.length + 1, text: tag }] }
        ////Restrict duplicate and case sensitive
        if (this.state.tags.filter(tagitem => tagitem.text.toLowerCase() == tag.text.toLowerCase()).length) {
            return;
        }
        this.setState({ tags: [...tags, tag] }
            , () => {
                this.props.onChange({ target: { name: this.props.name, value: this.processOutput(this.state.tags) } });
            });
    }
    // handleDrag(tag, currPos, newPos) {
    //     const tags = [...this.state.tags];

    //     // mutate array
    //     tags.splice(currPos, 1);
    //     tags.splice(newPos, 0, tag);

    //     // re-render
    //     this.setState({ tags },()=>{ this.props.onChange(event);});
    // }
    render() {
        const { p } = this.props;
        return (<React.Fragment>
            <ReactTags
                tags={this.state.tags}
                // tags={this.state.tags[props.index]}
                delimiters={this.delimiters}
                handleDelete={this.handleDelete}
                handleAddition={this.handleAddition}
                handleInputBlur={this.handleInputBlur}
                placeholder={this.props.placeholder || translate('seller.add_tags_placeholder')}
                // placeholder={translate('seller.products.create.entervariantattr').replace('{0}', this.props.variant.key)}
                // placeholder={translate('seller.products.create.entervariantattr').replace('{0}', "Asdf")}
                allowUnique={true}
                // handleDrag={this.handleDrag}
                allowDeleteFromEmptyInput={false}
                autofocus={false}
                allowAdditionFromPaste={false}
                readOnly={this.props.disabled}
            />
            {/* {validator} */}
        </React.Fragment>
        );
    }
}

class PasswordInput extends React.PureComponent {
    constructor(props) {
        super(props);
        this.toggle = this.toggle.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.checkRules = this.checkRules.bind(this);
        this.countCapitals = this.countCapitals.bind(this);
        this.countNumbers = this.countNumbers.bind(this);
        this.countSpecialCharacters = this.countSpecialCharacters.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleBlur = this.handleBlur.bind(this);
        this.state = {
            showAsPassword: true,
            minCharacters: this.props.minCharacters,
            //requireCapitals: this.props.requireCapitals,
            //requireNumbers: this.props.requireNumbers,
            forbiddenWords: [],//this.props.forbiddenWords,
            validatorVisible: false,
            isValidatorValid: {
                minChars: false,
                capitalLetters: false,
                numbers: false,
                words: false,
                all: false
            }
        };
    }
    handleFocus() {
        this.setState({
            focus: true,
            validatorVisible: true
        });
    }
    handleBlur() {
        // this.isValid();
        this.setState({
            focus: false,
            //errorVisible: !this.state.valid,
            validatorVisible: false
        });
    }
    handleChange(event) {
        if (this.props.validatorToolTip) {
            this.checkRules(event.target.value)
        }

        // call onChange method on the parent component for updating it's state
        //TODO if not using 'onChanged' anymore, delete it
        // if (this.props.onChanged) {
        //     this.props.onChanged(event);
        // }
        // else 
        if (this.props.onChange) {
            this.props.onChange(event);
        }
    }
    // validator function
    checkRules(value) {
        var validData = {
            minChars: !isEmpty(value) ? value.length >= parseInt(this.props.minCharacters) : false,
            capitalLetters: !this.props.requireCapitals || (!isEmpty(value) ? this.countCapitals(value) : false),
            numbers: !this.props.requireNumbers || (!isEmpty(value) ? this.countNumbers(value) > 0 : false),
            words: !this.props.requireWords || (!isEmpty(value) ? this.checkWords(value) : false),
            // specialCharacters: (!isEmpty(value) ? this.countSpecialCharacters(value) : false)
        }
        var allValid = (validData.minChars && validData.capitalLetters &&
            validData.words && validData.numbers
            //&& validData.specialCharacters
        );

        this.setState({
            isValidatorValid: validData,
            allValidatorValid: allValid,
            valid: allValid
        })
    }

    countCapitals(value) {
        var str = value;
        return str.replace(/[^A-Z]/g, "").length;
    }

    countNumbers(value) {
        return /\d/.test(value);
    }
    countSpecialCharacters(value) {
        return /[!@#$%^&*(),.?":{}|<>]/g.test(value);
    }

    checkWords(value) {
        var str = value;
        return str.replace(/[^A-Za-z]/g, "").length;
        // return _.some(this.state.forbiddenWords, function (word) {
        //     var matched = (word === value) ? true : "";
        //     return matched
        // })
    }
    toggle() {
        this.setState({ showAsPassword: !this.state.showAsPassword })
    }
    render() {
        const { p } = this.props;
        var validator;
        if (this.props.validatorToolTip) {
            validator =
                <PasswordValidator
                    ref="passwordValidator"
                    visible={this.state.validatorVisible}
                    name={this.props.text}
                    value={this.state.value}
                    validData={this.state.isValidatorValid}
                    valid={this.state.allValidatorValid}
                    forbiddenWords={this.state.forbiddenWords}
                    minCharacters={this.props.minCharacters}
                    requireCapitals={this.props.requireCapitals}
                    requireNumbers={this.props.requireNumbers}
                    requireWords={this.props.requireWords}
                />
        }

        return (<React.Fragment>
            <input type={this.state.showAsPassword ? this.props.type : ''} {...p}
                onChange={this.handleChange}
                // onChange={this.props.p.onChange ? this.props.p.onChange : this.handleChange} 
                onFocus={this.handleFocus}
                onBlur={this.handleBlur} />
            <i onClick={this.toggle} className={"far fa-eye" + (this.state.showAsPassword ? '-slash' : '')}></i>
            {validator}
        </React.Fragment>
        );
    }
}


class Error extends React.PureComponent {
    render() {
        if (!this.props.error) return null;
        return (
            <div className={(this.props.for ? "" : "is-invalid ") + "invalid-feedback"}>{translate(this.props.error)}</div>
        );
    }
}

class FormField extends React.PureComponent {
    render() {
        const props = this.props;
        const validator = (props.validator && props.validator[props.name]) || { isInvalid: false };
        var label_clsnames = classNames({
            'mand-field': props.required,
            'col-form-label mr-3 mb-0': (props.align == "horizontal" && props.type != 'onoffswitch'),
            'order-2 ml-2 mb-0': (props.type == 'onoffswitch' && props.align == "horizontal"),
            ' p-0':true
        })
        var formgroup_clsnames = classNames({
            'form-group basic-form2 d-flex':true,
            'flex-row align-items-center': (props.align == "horizontal"),
            'flex-column align-items-start': (props.align != "horizontal"),
            [props.formGroup_cust_class]: props.formGroup_cust_class
        })
        var inputwrapdivclsnames = classNames({
            // ' col-sm-3': (props.align == "horizontal")
        })
        if (props.type === 'checkbox') {
            // if (props.className && props.className.indexOf("onoff") != -1) {
            //     return (
            //         <div className={props.className}>
            //             <div className={"sms-cntr d-flex align-items-center"}>
            //                 <label className="switch">
            //                     {getField(props, validator)}
            //                     <span className="slider"></span>
            //                 </label>
            //                 <span className="ml-2" htmlFor={props.id || props.name}>
            //                     {translate(props.label)}
            //                 </span>
            //             </div>
            //         </div>

            //     )
            // } else {
            //     return (
            //         <div className={props.className || "custom-control custom-checkbox"}>
            //             {/* props.id should be same as htmlFor label */}
            //             {getField(props, validator)}
            //             <label className="custom-control-label" htmlFor={props.id}>
            //                 {translate(props.label)}
            //             </label>
            //             <Error for={props.name} error={validator.message} />
            //             {
            //                 props.subText &&
            //                 <span class="sep">{props.subText}</span>
            //             }
            //         </div>
            //     )
            // }
        } else {
            return (
                <div className={formgroup_clsnames }>
                    {/* {
                            (props.label || props.emptyLabel) && !props.labelPostField && !props.required &&
                            <label className={props.labelClassName}>
                                <span className="field-text">{translate(props.label)}</span>
                            </label>
                        }
                        {
                            (props.label || props.emptyLabel) && !props.labelPostField && props.required &&
                            <label className={props.labelClassName + ' mand-field'}>
                                <span className="field-text">{translate(props.label)}</span>
                                <sup className="mand">*</sup>
                            </label>
                        } */}

                    {/* {(props.label || props.emptyLabel) && !props.labelPostField && */}
                    {/* // <label className={props.labelClassName + (props.required?' mand-field':'')}> */}
                    {props.label && !props.hideLabel && <label className={props.lblClass || label_clsnames}>
                        {/* <span className={(props.lblSpanClass ? props.lblSpanClass : "field-text")}>{props.label ? translate(props.label) : '\u00A0'}</span> */}
                        {props.label ? translate(props.label) : '\u00A0'}
                        {props.label && props.required && <sup className="mand">*</sup>}
                        {props.label && props.mandatoryText && <small className="sub-text">{props.mandatoryText ? translate(props.mandatoryText) : '*'}</small>}
                    </label>}

                    {props.type != 'onoffswitch' && 
                    // <div className={props.fieldWrapClass || inputwrapdivclsnames}>
                        <React.Fragment>
                            <div className="col-form-field d-flex align-items-center">
                                {getField(props, validator)}
                                {!props.readOnly && <RemainingChars {...props} />}
                                {
                                    props.subText &&
                                    <span className="sep">{props.subText}</span>
                                }
                            </div>
                            <Error for={props.name} error={validator.message} />
                        </React.Fragment>
                    // </div>
                    }
                    {props.type == 'onoffswitch' &&
                        <div className={"sms-cntr d-flex align-items-center"}>
                            <label className={"switch "}>
                                {getField({ ...props, ...{ type: "checkbox", fieldClassName: "onoff " } }, validator)}
                                <span className="slider"></span>
                            </label>
                            {/* <span className="ml-2" htmlFor={props.id || props.name}>
                                    {translate(props.label)}
                                </span> */}
                        </div>
                    }

                    {/* {props.label && props.labelPostField && <label className={props.labelClassName}>{translate(props.label)}</label>} */}
                </div>
            )
        }
    }
}
export default FormField;


